export type EventColorItem = {
  value: string;
  label: string;
};

// Stored as-is in `sub_topics.event_color` and mapped to the planning palette by
// `features/calendar/utils/calendarEvents.ts`: keep these values stable.
export const EVENT_MATERIAL_COLORS: EventColorItem[] = [
  { value: '#1e88e5', label: 'Bleu' },
  { value: '#3949ab', label: 'Indigo' },
  { value: '#5e35b1', label: 'Violet foncé' },
  { value: '#8e24aa', label: 'Violet' },
  { value: '#d81b60', label: 'Rose' },
  { value: '#e53935', label: 'Rouge' },
  { value: '#fb8c00', label: 'Orange' },
  { value: '#ffa000', label: 'Ambre' },
  { value: '#43a047', label: 'Vert' },
  { value: '#00897b', label: 'Turquoise' },
  { value: '#0097a7', label: 'Cyan' },
  { value: '#546e7a', label: 'Gris bleuté' },
];
